import { Button } from '@savvy-kit/components/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from '@savvy-kit/components/dialog';
import { Text } from '@savvy-kit/foundations/text';
import { Info } from 'lucide-react';

import {
  CLIENT_PORTAL_TRANSFER_INFO_LABEL,
  CLIENT_PORTAL_TRANSFER_INFO_TITLE,
  clientPortalTransferFooterNote,
  clientPortalTransferInfoBody,
} from './constants';

type TransferFooterNoteProps = {
  readonly custodian: string | null;
};

export function TransferFooterNote({ custodian }: TransferFooterNoteProps) {
  const infoBody = clientPortalTransferInfoBody(custodian);

  return (
    <div className="flex items-center justify-center gap-1.5">
      <Text variant="body-sm" color="secondary">
        {clientPortalTransferFooterNote(custodian)}
      </Text>

      <Dialog>
        <DialogTrigger
          render={
            <Button
              variant="ghost"
              size="sm"
              aria-label={CLIENT_PORTAL_TRANSFER_INFO_LABEL}
              className="-m-2.5 box-content size-6 p-2.5"
            >
              <Info size={14} aria-hidden="true" />
            </Button>
          }
        />
        <DialogContent className="max-w-md">
          <DialogTitle>{CLIENT_PORTAL_TRANSFER_INFO_TITLE}</DialogTitle>
          <DialogDescription>{infoBody[0]}</DialogDescription>
          <Text variant="body-sm" color="secondary">
            {infoBody[1]}
          </Text>
        </DialogContent>
      </Dialog>
    </div>
  );
}
